import { Fragment, useState } from "react";
import {
  camelCase,
} from "../../../constants";
import { ParagraphText } from "../../../Libraries";
import { formatNum } from "../../../oscar-pos-core/constants";
import { Box, CircularProgress } from "@mui/material";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import { handleApi } from "../../../apis";
import { useNavigate } from "react-router-dom";
import { SELLER_PAYMENT_PDF, SELLER_REPORT } from "../../../apis/configuration";
import fileDownload from "js-file-download";
import { PopoverMenu } from "../../common";
import { DownloadIcon } from "../../../assets/icons/icon";
import { useSnackbar } from "../../../context/SnackbarContext";
import { dateFormatInNumberWithSpace } from "../../../utils";



const Listitem = ({ index, item, I18n }) => {
  const { description, payment_id, entry_date, balance, amount } = item || {};

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar()
  const onDownloadPDF = async () => {
    try {
      setLoading(true);
      const res = await handleApi(
        SELLER_PAYMENT_PDF,
        { payment_id },
        null,
        navigate,
        null,
        { responseType: "blob" },
      );
      fileDownload(res, "payment_receipt.pdf");
      showSnackbar({
        message: "PDF downloaded successfully",
        severity: "success",
        icon: "",
      });

      triggerLogEvent(analytics, "sc_ledger_download_payment_pdf", {});
    } catch (err) {
      if (err?.response?.data?.message)
        showSnackbar({
          message: err.response.data.message,
          severity: "error",
          icon: "",
        });
    } finally {
      setLoading(false);
    }
  };

  const onDownloadExcelFiles = async (item) => {
    let params = { type: item.type };

    try {
      setLoading(true);

      if (item.type == "payment_report") params.payment_id = payment_id;
      const res = await handleApi(SELLER_REPORT, params, null, navigate, null, {
        responseType: "blob",
      });
      fileDownload(res, `${item.name}.xls`);
      showSnackbar({
        message: "File downloaded successfully",
        severity: "success",
        icon: "",
      });
      if (item.value === "payment_detail") {
        triggerLogEvent(analytics, "sc_ledger_download_payment_detail", {
          payment_id,
        });
      } else if (item.value === "outstanding_orders") {
        triggerLogEvent(analytics, "sc_ledger_download_outstanding", {});
      } else if (item.value === "return_orders") {
        triggerLogEvent(analytics, "sc_ledger_download_return", {});
      }
    } catch (error) {
      if (error.response) {
        const errorBlob = error.response.data;
        errorBlob.text().then((errorText) => {
          const errorJson = JSON.parse(errorText);
          showSnackbar({
            message: errorJson.message,
            severity: "error",
            icon: "",
          });
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const actions = [
    {
      label: (
        <Fragment>
          <DownloadIcon width={20} height={18} id="download_black_btn" />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n["payment_pdf"]}
          </ParagraphText>
        </Fragment>
      ),
      action: (e) => {
        e.stopPropagation();
        onDownloadPDF();
      },
    },
    {
      label: (
        <Fragment>
          <DownloadIcon width={20} height={18} id="download_black_btn" />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n["payment_detail"]}
          </ParagraphText>
        </Fragment>
      ),
      action: (e) => {
        e.stopPropagation();
        onDownloadExcelFiles({
          name: "payment_detail",
          value: "payment_detail",
          type: "payment_report",
        });
      },
    },
    {
      label: (
        <Fragment>
          <DownloadIcon width={20} height={18} id="download_black_btn" />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n["outstanding_orders"]}
          </ParagraphText>
        </Fragment>
      ),
      action: (e) => {
        e.stopPropagation();
        onDownloadExcelFiles({
          name: "outstanding_orders",
          value: "outstanding_orders",
          type: "outstanding_orders",
        });
      },
    },
    {
      label: (
        <Fragment>
          <DownloadIcon width={20} height={18} id="download_black_btn" />
          <ParagraphText className="textCapitalizeFirstLetter">
            {I18n["return_orders"]}
          </ParagraphText>
        </Fragment>
      ),
      action: (e) => {
        e.stopPropagation();
        onDownloadExcelFiles({
          name: "return_orders",
          value: "return_orders",
          type: "returns",
        });
      },
    },

  ];

  return (

    <Box
      id={`ledger_list_${index}`}
      className="invoiceListTableBody AccountItemListWrapper"

    >
      <Box
        className={`invListTableHeaderCol sixColumn textLeft sidebarOption`}
      >
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor">
          {dateFormatInNumberWithSpace(entry_date)}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol sixColumn textLeft`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textLeft newFontColor displayFlex">
          {camelCase(description)}
        </ParagraphText>
      </Box>


      <Box className={`invListTableHeaderCol sixColumn textRight`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textRight newFontColor amountColumnInnerWrapper">
          {amount < 0 ? `Rs. ${formatNum(Math.abs(amount))}` : "-"}
        </ParagraphText>
      </Box>

      <Box className={`invListTableHeaderCol sixColumn textRight`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textRight newFontColor amountColumnInnerWrapper">
          {amount > 0 ? `Rs. ${formatNum(Math.abs(amount))}` : "-"}
        </ParagraphText>
      </Box>
      <Box className={`invListTableHeaderCol sixColumn textRight`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textRight newFontColor amountColumnInnerWrapper">
          {`Rs. ${formatNum(balance)}`}
        </ParagraphText>
      </Box>



      <Box className={`amountColumnInnerWrapper invListTableHeaderCol sixColumn textCenter`}>
        <ParagraphText className="fontSize14 fontWeight400 truncateOneLine textCenter newFontColor">
          <span className="truncate"></span>
          <div className="tblOptnBox" role="button">
            <PopoverMenu
              id="view_ledger_list_item_menu"
              menuOptions={actions}
              popOverStyle={{
                marginLeft: "5px",
                borderRadius: "16px !important",
              }}
              popoverButton={
                (loading) && (
                  <CircularProgress size={"15px"} />
                )
              }
              disabled={loading || !Boolean(payment_id)}
            />
          </div>
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default Listitem;
